import { render, staticRenderFns } from "./GetScore.vue?vue&type=template&id=ddbbfa22&scoped=true&"
import script from "./GetScore.vue?vue&type=script&lang=js&"
export * from "./GetScore.vue?vue&type=script&lang=js&"
import style0 from "./GetScore.vue?vue&type=style&index=0&id=ddbbfa22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbbfa22",
  null
  
)

export default component.exports